import React from 'react'
import {motion} from 'framer-motion'
import { Box, Card, CardMedia, Grid, Typography } from '@mui/material'
import styled from '@emotion/styled'
import useStyles from './MainTitle'
import { NavLink } from 'react-router-dom'

const CardItem = styled("div")(({theme}) => ({
    position: "absolute",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    overflow: "hidden",
    border: `1px solid ${theme.palette.grey.dark}`,
    "&:hover": {
        "#overlay": {
            position: "absolute",
            top: "0",
            left: "0",
            width: "100%",
            height: "100%",
            backgroundColor: theme.palette.primary.overlay,
            transition: "all 0.4s ease-in-out"
        },
        "#image": {
            transform: "scale(1.3) rotate(-10deg)",
            filter: "blur(5px)",
            transition: "all 0.4s ease-in-out",
            transitionDelay: ".1s"
        },
        "#overlay-text": {
            transform: "translateY(0)"
        }
    }
}))
const CardItemTitle = styled("div")(({theme}) => ({
    padding: "0 10px",
    width: "100%",
    background: theme.palette.background.default,
    height: "60px",
    lineHeight: "60px",
    transform: "translateY(-40px)",
    textAlign: "center",
    border: `1px solid ${theme.palette.grey.dark}`,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    [theme.breakpoints.up("md")]: {
        display: "none",
      },
}))
function Item({id, img, title, link, delay}) {
    const classes = useStyles()
  return (
    <>
    <Grid item xs={12} md={6} lg={4} sx={{marginBottom: {xs: "-40px", md: "0"}}}>
        <motion.div layout initial={{opacity: 0}} animate={{opacity: 1, transition: {delay: delay}}} exit={{opacity: 0}} className="item">
            <Card component={NavLink} target="_blank" to={link} sx={{ position: "relative", width: "100%",height: "240px", boxShadow: "none" , display: "flex" ,justifyContent: "center", alignItems: "center", overflow: "hidden"}}>
                <CardItem>
                    <CardMedia
                    id="image"
                    className={classes.media}
                    image={img}
                    title="Image"
                    sx={{width: "100%", height: "100%"}}
                    >    
                    </CardMedia>
                    <Box id='overlay' sx={{display: {xs: "none", md: "flex"}, justifyContent: "center", alignItems: "center"}} component={"p"}>
                        <Typography id='overlay-text' sx={{transform: "translateY(200px)", transition: ".5s ease", fontSize: "1.5rem", color: "#fff"}}>
                            {title}
                        </Typography>
                    </Box>
                </CardItem>
            </Card>
            <CardItemTitle sx={{display: {xs: "flex", md: "none"}}}>
                <Typography sx={{fontWeight: "600"}}>{title}</Typography>
                <Typography component={NavLink} target="_blank" to={link} sx={{fontSize: "15px", background: "#0066ff", color: "#fff", padding: "4px 8px", borderRadius: "10px", textDecoration: "none"}}>
                    Live Demo
                </Typography>
            </CardItemTitle>
        </motion.div>
    </Grid>
    </>
  )
}

export default Item